'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('history', {
      url: '/history/:id',
      template: '<history></history>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/history/view/history.routes.js